export default {"src":"/_next/static/media/zhk-dark-logo.ab40b3b1.svg","height":422,"width":589,"blurWidth":0,"blurHeight":0};